module.exports = __webpack_public_path__ + "static/media/right-icon.86c723f8.svg";